/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_LeadInputs */

const en_dr_steps_lead = /** @type {(inputs: Dr_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every step is scaffolded by evidence on remote collaboration and AI-assisted ideation (RISET_DESIGN_ROOM_TIM.md §2) — not a blank canvas where the loudest voice wins.`)
};

const id_dr_steps_lead = /** @type {(inputs: Dr_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap langkah dibingkai dari bukti soal kolaborasi jarak jauh dan ideasi berbantuan AI (RISET_DESIGN_ROOM_TIM.md §2) — bukan kanvas kosong tempat suara paling keras yang menang.`)
};

/**
* | output |
* | --- |
* | "Every step is scaffolded by evidence on remote collaboration and AI-assisted ideation (RISET_DESIGN_ROOM_TIM.md §2) — not a blank canvas where the loudest vo..." |
*
* @param {Dr_Steps_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_lead = /** @type {((inputs?: Dr_Steps_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_lead(inputs)
	return en_dr_steps_lead(inputs)
});